<template>
    <div class="device-set">
        <div class="actions">
            <div class="box">
                <div class="actions-func">
                    <Select v-model="conditions.ws_id" class="margin-r10 shadow112006" style="width:150px">
                        <Option :value="-1">{{$t('all')}}</Option>
                        <Option :value="0">{{$t('a_unassignedWorkshop')}}</Option>
                        <Option v-for="item in allShops" :key="item.ws_id" :value="item.ws_id">{{item.name}}</Option>
                    </Select>
                    <Input v-model="conditions.name" :placeholder="$t('groupName')" style="width:150px;" class="margin-r10 shadow112006"/>
                    <Button type="info" icon="md-search" @click="search" class="shadow112006">{{$t('search')}}</Button>
                </div>
                <div class="btns" v-if="$store.state.user.rank==1">
                    <Button type="primary" icon="md-add" @click="addModal.show = true" class="margin-r10 shadow112006">{{$t('addGroup')}}</Button>
                </div>
            </div>
        </div>
        <!-- table -->
        <Table border stripe :loading="loading" :columns="columns" :data="allGroups" height="873"/>
        <!-- 底部分页 -->
        <DeviceFooter isShowPage :page="page" :pageSizeOptions="[18, 36, 72]" @change-page="changePage" @change-page-size="changePageSize"></DeviceFooter>
        <!-- 添加机组 -->
        <Modal v-model="addModal.show" @on-ok="doAdd" width="400" @on-visible-change="addModalVisibleChange">
            <p slot="header">
                <Icon type="md-add"/>
                <span>{{$t('addGroup')}}</span>
            </p>
            <Form :model="addModal" :label-width="80">
                <FormItem :label="$t('groupName')">
                    <Input v-model="addModal.params.name" :placeholder="$t('groupName')"/>
                </FormItem>
                <FormItem :label="$t('tagName')">
                    <Select v-model="addModal.params.ws_id">
                        <Option :value="0">{{$t('a_NonAssignmentWorkshop')}}</Option>
                        <Option v-for="item in allShops" :key="item.ws_id" :value="item.ws_id">{{item.name}}</Option>
                    </Select>
                </FormItem>
                <FormItem :label="$t('b_groupSort')">
                    <InputNumber v-model="addModal.params.sort" :placeholder="$t('b_groupSort')" :precision="0" style="width:100%"/>
                </FormItem>
                <FormItem :label="$t('b_selectDevice')" style="margin-bottom:0;">
                    <Select v-model="addModal.params.dev_idsArr" multiple>
                        <Option v-for="item in noUsedDevices" :key="`kind${item.dev_id}`" :value="item.dev_id">{{item.name}}</Option>
                    </Select>
                </FormItem>
            </Form>
        </Modal>
        <!-- 编辑机组 -->
        <Modal v-model="editModal.show" @on-ok="doEdit" width="400">
            <p slot="header">
                <Icon type="md-build"/>
                <span>编辑机组</span>
            </p>
            <Form :model="editModal" :label-width="80">
                <FormItem :label="$t('groupName')">
                    <Input v-model="editModal.params.name" :placeholder="$t('groupName')"/>
                </FormItem>
                <FormItem :label="$t('tagName')">
                    <Select v-model="editModal.params.ws_id">
                        <Option :value="0">{{$t('a_NonAssignmentWorkshop')}}</Option>
                        <Option v-for="item in allShops" :key="item.ws_id" :value="item.ws_id">{{item.name}}</Option>
                    </Select>
                </FormItem>
                <FormItem :label="$t('b_groupSort')" style="margin-bottom:0;">
                    <InputNumber :min="0" v-model="editModal.params.sort" :precision="0" :placeholder="$t('b_groupSort')" style="width:100%"></InputNumber>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>
<script>
import DeviceFooter from '@/views/main_components/footer.vue';
import Axios from 'axios';
import AxiosUrl from '@/axiosurl.js';
import Moment from 'moment';
export default {
    components: {
        DeviceFooter
    },
    created() {
        this.$store.commit('upNavbar', 12);
    },
    mounted() {
        this.getGroups();
        this.getShops();
    },
    data() {
        let columns = [
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('groupName'));
                },
                key: 'name',
                align: 'center'
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('belongTag'));
                },
                key: 'ws_name',
                align: 'center'
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('b_groupSort'));
                },
                key: 'sort',
                align: 'center'
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('addTime'));
                },
                align: 'center',
                render: (h, params) => {
                    return h('span', {}, Moment(params.row.created).format('YYYY-MM-DD HH:mm:ss'));
                }
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('updateTime'));
                },
                align: 'center',
                render: (h, params) => {
                    return h('span', {}, Moment(params.row.updated).format('YYYY-MM-DD HH:mm:ss'));
                }
            },
            {
                renderHeader: (h, params) => {
                    return h('span', {}, this.$t('action'));
                },
                align: 'center',
                width: 200,
                render: (h, params) => {
                    return h('div', [
                        h(
                            'Button',
                            {
                                props: {
                                    type: 'primary',
                                    size: 'small'
                                },
                                style: {
                                    marginRight: '10px'
                                },
                                on: {
                                    click: () => {
                                        this.editModal.params = Object.assign({}, params.row);
                                        this.editModal.show = true;
                                    }
                                }
                            },
                            this.$t('edit')
                        ),
                        h(
                            'Button',
                            {
                                props: {
                                    type: 'error',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.$Modal.confirm({
                                            title: this.$t('delDevice'),
                                            content: `${this.$t('a_sureDelDevice')}：${params.row.name}？？？`,
                                            onOk: () => {
                                                this.delDevice(params.row.gid);
                                            }
                                        });
                                    }
                                }
                            },
                            this.$t('delete')
                        )
                    ]);
                }
            }
        ];
        if (this.$store.state.user.rank != 1) {
            columns.pop();
        }
        return {
            loading: true,
            columns,
            allGroups: [], //所有的机组
            allShops: [], //所有工厂
            // 查询信息
            conditions: {
                page: 1,
                size: 18,
                cid: this.$store.state.user.cid,
                ws_id: -1,
                name: '' // 机组名称
            },
            // 分页
            page: {
                page: 1, // 当前页数
                total: 0, // 总数
                size: 18 // 每页数量
            },
            //添加机组
            noUsedDevices: [], //未使用（无机组）的设备
            addModal: {
                show: false,
                params: {
                    cid: this.$store.state.user.cid,
                    name: '',
                    ws_id: 0,
                    sort: 0,
                    dev_idsArr: [],
                    dev_ids: ''
                }
            },
            //编辑机组
            editModal: {
                show: false,
                params: {}
            }
        };
    },
    methods: {
        // 添加机组的modal状态改变
        addModalVisibleChange(show) {
            if (show) {
                Axios.get(AxiosUrl.device.select, {
                    params: {
                        cid: this.$store.state.user.cid,
                        gid: 0
                    }
                }).then(res => {
                    if (res.data.code == 200) {
                        this.noUsedDevices = res.data.data;
                    } else {
                        console.log(res.data.msg);
                    }
                });
            }
        },
        // 获得所有机组的信息
        getGroups() {
            this.loading = true;
            let conditions = Object.assign({}, this.conditions);
            conditions.ws_id = conditions.ws_id == -1 ? '' : conditions.ws_id;
            Axios.get(AxiosUrl.group.list, {
                params: conditions
            }).then(res => {
                if (res.data.code == 200) {
                    let { total, list } = res.data.data;
                    this.page.total = total;
                    this.allGroups = list;
                    this.loading = false;
                } else {
                    console.log(res.data.msg);
                }
            });
        },
        // 获取车间列表
        getShops() {
            // 有效工厂
            this.allShops = [];
            Axios.get(AxiosUrl.workshop.select, {
                params: {
                    cid: this.$store.state.user.cid
                }
            }).then(res => {
                if (res.data.code == 200) {
                    this.allShops = res.data.data;
                } else {
                    console.log(res.data.msg);
                }
            });
        },
        //删除机组
        delDevice(gid) {
            Axios.get(AxiosUrl.group.del, {
                params: {
                    cid: this.$store.state.user.cid,
                    gids: gid
                }
            }).then(res => {
                if (res.data.code == 200) {
                    this.$Message.success(this.$t('deleteSuccess'));
                    this.getGroups();
                } else {
                    console.log(res.data.msg);
                }
            });
        },
        // 确认添加机组
        doAdd() {
            if (this.addModal.params.name == '') {
                this.$Message.error(this.$t('a_hasEmpty'));
                return;
            }
            if (this.addModal.params.dev_idsArr.length != 0) {
                this.addModal.params.dev_ids = this.addModal.params.dev_idsArr.join('-');
            }
            Axios.get(AxiosUrl.group.add, {
                params: this.addModal.params
            }).then(res => {
                if (res.data.code == 200) {
                    this.getGroups();
                    this.$Message.success(this.$t('addSuccess'));
                    this.$emit('refresh');
                    this.addModal.params.name = '';
                    this.addModal.params.sort = 0;
                    this.addModal.params.ws_id = 0;
                    this.addModal.params.dev_idsArr = [];
                    this.addModal.params.dev_ids = '';
                } else {
                    console.log(res.data.msg);
                }
            });
        },
        // 编辑机组
        doEdit() {
            Axios.get(AxiosUrl.group.edit, {
                params: this.editModal.params
            }).then(res => {
                if (res.data.code == 200) {
                    this.$Message.success(this.$t('updateSuccess'));
                    this.getGroups();
                } else {
                    console.log(res.data.msg);
                }
            });
        },
        // 查询
        search() {
            this.getGroups();
        },
        // 改变页数
        changePage(page) {
            this.conditions.page = page;
            this.getGroups();
        },
        // 改变每页数量
        changePageSize(size) {
            this.conditions.size = size;
            this.getGroups();
        }
    }
};
</script>
<style lang="less">
.device-set {
    .ivu-input-number {
        width: 100%;
    }
}
</style>





// WEBPACK FOOTER //
// src/views/system/groupManage.vue